<script setup lang="ts">
import { formatFileSize } from '@/utils'
import { HierarchicAplosFileViewModel } from '../models/HierarchicAplosFileViewModel';

const props = defineProps<{
  record: HierarchicAplosFileViewModel
  index?: number
  selectable?: boolean
  onCellClick?: (record: any, e?: Event) => void
}>()

function handleClick(e?: Event) {
  if (props.selectable && props.onCellClick) {
    props.onCellClick(props.record, e)
  }
}
</script>

<template>
  <div :class="{ 'cursor-pointer': selectable }" @click="handleClick">
    {{ record.size ? formatFileSize(record.size) : 'N/A' }}
  </div>
</template>
